import { useState, useEffect, useCallback } from "react";
import { listDueDateChanges } from "../services/dueDateChangesApi";

export function useDueDateChangeLog(entityType, entityId) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!entityId) return;
    setLoading(true);
    try {
      const data = await listDueDateChanges(entityType, entityId);
      setHistory(data);
    } catch {
      setHistory([]);
    } finally {
      setLoading(false);
    }
  }, [entityType, entityId]);

  useEffect(() => {
    load();
  }, [load]);

  return { history, count: history.length, loading, reload: load };
}
